import React from 'react';

import OrderSearchData from './OrderSearchData';

const OrderSearch = props => {
  
  const { apiToken } = props;
  
  return (
    <div>
      <OrderSearchData apiToken={apiToken}/>
    </div>
  )
};

export default OrderSearch;